import { AuthProviderProps } from 'react-oidc-context'
import { WebStorageStateStore } from 'oidc-client-ts'

export function createOidcConfig(): AuthProviderProps {
  const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL || 'https://iam.pmgsc-data.org/auth'
  const realm = import.meta.env.VITE_KEYCLOAK_REALM || 'corp'
  const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'api-ops'

  const authority = `${keycloakUrl}/realms/${realm}`

  return {
    authority,
    client_id: clientId,
    redirect_uri: `${window.location.origin}/callback`,
    post_logout_redirect_uri: `${window.location.origin}/login`,
    silent_redirect_uri: `${window.location.origin}/silent-check-sso.html`,
    response_type: 'code',
    // Note: Add 'offline_access' to enable refresh tokens (requires Keycloak client config)
    scope: 'openid profile email',
    automaticSilentRenew: true,
    loadUserInfo: true,
    onSigninCallback: () => {
      // Remove the code and state from the URL after successful login
      window.history.replaceState({}, document.title, window.location.pathname)
    },
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    metadata: {
      issuer: authority,
      authorization_endpoint: `${authority}/protocol/openid-connect/auth`,
      token_endpoint: `${authority}/protocol/openid-connect/token`,
      userinfo_endpoint: `${authority}/protocol/openid-connect/userinfo`,
      end_session_endpoint: `${authority}/protocol/openid-connect/logout`,
      jwks_uri: `${authority}/protocol/openid-connect/certs`,
    },
  }
}
